// 法人情報新規登録・法人（ユーザー）編集・法人（ユーザー）削除の確認画面
import React, { useEffect, memo } from 'react';
import { Button } from 'react-bootstrap';
import { scrollPageTop } from '../Scroll';
import { ResponseDetailType, GroupLabelType } from '../types/Corporate';
import { GroupLabel, LabelData } from '../const/Corporate';
import { CorporationInfoFormatValue } from '../Common';

interface Props {
  verified_data?: ResponseDetailType;
  setIsConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  handleConfirm: () => void;
}
const CorporateInfoConfirm: React.FC<Props> = ({ verified_data, setIsConfirm, handleConfirm }) => {
  useEffect(() => {
    // 画面遷移時に画面トップへスクロール
    scrollPageTop();
  }, []);

  /**
   * 【戻る】ボタン押下時の処理
   */
  const handleBack = () => {
    setIsConfirm(false);
    // 元の画面に遷移時に画面トップへスクロール
    scrollPageTop();
  };

  return (
    <>
      <p className="contents_title mb-5">法人情報編集(確認)</p>
      <div className="group_wrapper">
        {GroupLabel.map((item: GroupLabelType) => (
          <div className="text_field_wrapper" key={item.type}>
            <p className="section_label">{item.label}</p>
            {Object.entries(LabelData[item.type]).map(([key, value]) => (
              <dl className="field_section" key={key}>
                <dt className="field_label">{typeof value === 'string' && value}</dt>
                <dd className="field_data">
                  {verified_data &&
                    Object.entries(verified_data.corporate_information).map(
                      ([key2, value2]) => key2 === key && CorporationInfoFormatValue(value2, key)
                    )}
                </dd>
              </dl>
            ))}
          </div>
        ))}
        <dl className="field_section mt-5">
          <dt className="field_label">編集コメント</dt>
          <dd className="field_data">{verified_data?.corporate_information.temp_comment}</dd>
        </dl>
      </div>
      <div className="w_button_section mx-auto my-5 d-flex justify-content-between">
        <Button className="btn-mini btn-text-color" variant="outline-success" onClick={handleBack}>
          戻る
        </Button>
        <Button className="btn-mini btn-success" onClick={handleConfirm}>
          確認
        </Button>
      </div>
    </>
  );
};

export default memo(CorporateInfoConfirm);
